import React from 'react';
import $ from 'jquery';

import BaseClass from '@/pages/BaseClass';

import {CommonValue, formatVideoTime, httpPost, message, pcUrl,} from '@/utils/tools';

export default class App extends BaseClass {
    constructor(props) {
        super(props);
        this.state = {
            'id': 0,
            'info': {
                'subject': '',
                'chapterList': [],
            },
            'categoryList': [],
            'peopleList': {},
            'numberList': ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十'],
        };
    }

    componentDidMount() {
        console.log(this.props);
        let id = this.props.match.params.id;
        if (!id) this.props.history.goBack();
        this.state.id = id;

        this.getCategoryList();
        this.getInfo();
        this.getPeopleList();
        this.shiftInit();
    }

    shiftInit() {
        $('.class-shift').find('ul li a').on('click', function (e) {
            e.preventDefault();
            var href = $(this).attr('href').replace('#', '');

            var top = $('[name="' + href + '"]').position().top;
            var _this = this;

            //修改class
            $('html ,body').animate({scrollTop: top}, 300, function () {
                $('.class-shift').find('ul li a.now').parent().prev().find('span').css({'border-right': '1px solid white'});
                $('.class-shift').find('ul li a').removeClass('now');

                $(_this).parent().prev().find('span').css({
                    'border-right': 'none',
                });
                $(_this).addClass('now');
            });
        });
    }

    getCategoryList() {
        let url = pcUrl('/course/subject');
        httpPost(url, {}, 'get')
            .then(data => {
                this.setState({
                    'categoryList': data,
                });
            });
    }

    getPeopleList() {
        let url = pcUrl('/dict/data', {'dictType': 'school_type'});
        httpPost(url, {}, 'get', {
            'rawResponse': true,
        })
            .then(data => {
                let peopleList = {};
                data.rows.forEach(row => {
                    peopleList[row['dictValue']] = row['dictLabel'];
                });
                this.setState({peopleList});
            });
    }

    getInfo() {
        let url = pcUrl('/course/' + this.state.id);
        httpPost(url, {}, 'get')
            .then(data => {
                this.setState({
                    'info': data,
                });
            });
    }

    addClass() {
        if(!window.confirm('加入课题后，不可更换课题，是否确认选择该课题？')){
            return;
        }

        let url = pcUrl('/study/course/' + this.state.id);
        httpPost(url, {}, 'POST', {
            'rawCode': true
        })
            .then(data => {
                console.log(data);
                if (0 == data.code) {
                    message('您已成功加入该课题，可以到个人中心->学习中心查看了', 'success');
                } else if (301 == data.code) {
                    data = data.data;
                    CommonValue.set('pay_info', data);
                    this.props.history.push('/order');
                } else if (500 == data.code) {
                    message(data.msg);
                }
            });
    }

    render() {
        return (
            <>
                <div className="height-20"></div>
                <div className="body">
                    <div className="class-head">
                        <div className="class-head-left">
                            <video src={"https://vod.jscqe.com/" + this.state.info.profileVideoUrl} autoplay muted controls
                                   poster={"https://vod.jscqe.com/" + this.state.info.thumbUrl || require("@/assets/images/class_thumb.jpg")}></video>
                        </div>
                        <div className="class-head-right">
                            <dl>
                                <dt>
                                    {this.state.info.name}
                                </dt>
                                <dd className="desc">
                                    课程简介：
                                    {this.state.info['profile']}
                                </dd>
                                <dd className="category">
                                    <div className="row">
                                        <div className="col-6">
                                            关联专业：
                                            {this.state.info['subject'].split(',').map(key => {
                                                let find;
                                                this.state.categoryList.some(row => {
                                                    find = row.s.find(row1 => row1.v == key);
                                                    if (find)
                                                        return true;
                                                });
                                                return find ? find.n : '';
                                            }).join('，') || '无'}
                                        </div>
                                        <div className="col-6">
                                            适用人群：{this.state.peopleList[this.state.info['people']]}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            关键词：{this.state.info.keywords}
                                        </div>
                                        <div className="col-6">
                                            课题热度：{this.state.info.heat || 0}人
                                        </div>
                                    </div>
                                </dd>
                                <dd className="buy">
                                    <button className="button button-blue-linear" onClick={() => this.addClass()}>加入课题
                                    </button>
                                </dd>
                            </dl>
                        </div>
                        <div className="clear"></div>
                    </div>
                    <div className="height-20"></div>
                    <div className="class-left">
                        <div className="class-shift">
                            <ul>
                                <li><a href="#class" className="now"> 课程内容 </a></li>
                                <li><a href="#teacher"> 导师介绍 </a></li>
                                <li><a href="#category"> 课题目录 </a></li>
                            </ul>
                        </div>
                        <div className="height-30"></div>
                        <div className="class-left-panel">
                            <a name="class"></a>
                            <div className="captain">
                                <h3> 课程内容 </h3>
                            </div>
                            <div className="panel-body">
                                <div className="class-desc">
                                    <img src={"https://vod.jscqe.com/" + this.state.info.contentUrl}/>
                                </div>
                            </div>
                        </div>
                        <div className="height-30"></div>
                        <div className="class-left-panel">
                            <a name="teacher"></a>
                            <div className="captain">
                                <h3> 导师介绍 </h3>
                            </div>
                            <div className="panel-body">
                                <div className="class-teacher">
                                    <img src={"https://vod.jscqe.com/" + this.state.info.teacherUrl}/>
                                </div>
                            </div>
                        </div>
                        <div className="height-30"></div>
                        <div className="class-left-panel">
                            <a name="category"></a>
                            <div className="captain">
                                <h3> 课程内容 </h3>
                            </div>
                            <div className="panel-body">
                                <div className="class-course">
                                    {this.state.info.chapterList.map((row, index) => (
                                        <dl>
                                            <dt>
                                                {/*this.state.numberList[(index+1)]+'、'+*/row.name}
                                            </dt>
                                            {row.nodeList && row.nodeList.length > 0 && (
                                                <dd>
                                                    <ul>
                                                        {row.nodeList.map((row1, index1) => (
                                                            <li>
																<span className="float-right">
																	<span className="clips play-ico"></span>
                                                                    &nbsp;&nbsp;
                                                                    {formatVideoTime(row1.videoTime)}
																</span>
                                                                <span> {/*(index1+1)+'.'+*/row1.name} </span>
                                                                <div className="clear"></div>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </dd>
                                            )}
                                        </dl>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="class-right">
                        <div className="class-right-panel">
                            <div className="captain">
                                <h3>流程图</h3>
                            </div>
                            <div className="panel-body">
                                <img src={require('@/assets/images/gant_thumb.jpg')}/>
                            </div>
                        </div>
                    </div>
                    <div className="clear"></div>
                </div>
            </>
        );
    }
}

